<app-header></app-header>
<section class="patinet_support" id="patinet_support">
  <div class="content-container">
    <div class="pure-g">
      <div class="pure-u-1">
        <div class="content">
          <h2>
            Patient Support
          </h2>
          <p>
            A seamless experience from enrolment to treatment, with ongoing support and coordination of care with your
            healthcare team.
          </p>
          <h3>
            What you can expect from our program:
          </h3>
        </div>
        <div class="image">
          <img src="/assets/img/patient_program.png" alt="Patient Program" class="mobilehidden" />
          <div class="text-links-desktop mobilehidden">
            <div class="enrollment">
              <div class="text-wrapper">
                <div class="link"><a (click)="showpopup('enrollment')">Enrolment</a></div>
                <app-patient-support *ngIf="enrollment" [messageh3]="enrollmenth3" [messagep]="enrollmentp"
                  [path]="enrollmentpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
              </div>
            </div>
            <div class="supplies">
              <div class="text-wrapper">
                <div class="link"><a (click)="showpopup('orderingsupplies')">Ordering <br>Supplies</a></div>
                <app-patient-support *ngIf="orderingsupplies" [messageh3]="ordersuupliesh3" [messagep]="ordersuupliesp"
                  [path]="ordersuupliespath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
              </div>
            </div>
            <div class="coordination">
              <div class="text-wrapper">
                <div class="link"><a (click)="showpopup('productcoordination')">Product <br>Coordination</a></div>
                <app-patient-support *ngIf="productcoordination" [messageh3]="productcoorh3" [messagep]="productcoorp"
                  [path]="productcoorpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
              </div>
            </div>
            <div class="training">
              <div class="text-wrapper">
                <div class="link"><a (click)="showpopup('trainingsupport')">Training and <br>Support</a></div>
                <app-patient-support *ngIf="trainingsupport" [messageh3]="trainingsuph3" [messagep]="trainingsupp"
                  [path]="trainingsuppath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
              </div>
            </div>
            <div class="reports">
              <div class="text-wrapper">
                <div class="link"><a (click)="showpopup('reportstophysician')">Reports to Physician <br>and Healthcare
                    Team</a></div>
                <app-patient-support *ngIf="reportstophysician" [messageh3]="physicianh3" [messagep]="physicianp"
                  [path]="physicianpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
              </div>
            </div>
          </div>

          <div class="desktophidden text-links-mobile">
            <app-patient-support *ngIf="enrollment" [messageh3]="enrollmenth3" [messagep]="enrollmentp"
              [path]="enrollmentpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
            <app-patient-support *ngIf="orderingsupplies" [messageh3]="ordersuupliesh3" [messagep]="ordersuupliesp"
              [path]="ordersuupliespath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
            <app-patient-support *ngIf="productcoordination" [messageh3]="productcoorh3" [messagep]="productcoorp"
              [path]="productcoorpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
            <app-patient-support *ngIf="trainingsupport" [messageh3]="trainingsuph3" [messagep]="trainingsupp"
              [path]="trainingsuppath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
            <app-patient-support *ngIf="reportstophysician" [messageh3]="physicianh3" [messagep]="physicianp"
              [path]="physicianpath" [close]="close" (buttonWasClicked)="popupclose()"></app-patient-support>
            <div class="pure-g">
              <div class="pure-u-md-5-24 pure-u-1-24"></div>
              <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                <p><a (click)="showpopup('enrollment')">Enrolment</a></p>
              </div>
              <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                <p><a (click)="showpopup('orderingsupplies')">Ordering Supplies</a></p>
              </div>
              <div class="pure-u-md-5-24 pure-u-1-24"></div>
              <div class="pure-u-md-5-24 pure-u-1-24"></div>
              <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                <p><a (click)="showpopup('productcoordination')">Product <br />Coordination</a></p>
              </div>
              <div class="pure-u-md-7-24 pure-u-11-24 text-wrapper-mobile">
                <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                <p><a (click)="showpopup('trainingsupport')">Training and <br />Support</a></p>
              </div>
              <div class="pure-u-md-5-24 pure-u-1-24"></div>
              <div class="pure-u-1 text-wrapper-mobile">
                <img src="/assets/img/patient_program_mob_bg.png" alt="Patient Program" />
                <p><a (click)="showpopup('reportstophysician')">Reports to Physician <br />and Healthcare Team</a></p>
              </div>
            </div>
          </div>
        </div>


        <div class="enrol-wrapper">
          <a href="#">
            <div class="enrol-section">
              <div class="text">
                To register, please speak to your healthcare professional.
              </div>
            </div>
          </a>
          <div class="content-section">
            <p>
              Are you a healthcare professional?<br>
              <span>Visit the CSL Behring HCP hub to download an enrolment form.</span>
            </p>
            <a class="btn" href="https://hcp.cslbehring.ca/" target="_blank" title="Visit now">
              Visit now
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section id="sec_cslnews">
  <div class="csl_news">

    <div class="content-container">
      <h2>What’s New: CSL PLUS <br />Supply Ordering Portal</h2>
      <div class="pure-g content_wrap">
        <div class="pure-u-md-6-24 pure-u-xl-3-24"></div>
        <div class="pure-u-md-12-24 pure-u-xl-18-24">
          <p>Ordering supplies and accessing insightful information is now easier with the new <span>Self
              Ordering Web-based Portal</span> for our patients and HCPs.* It’s simple, fast and
            secure.
            In just a few clicks, you can:</p>
        </div>
        <div class="pure-u-md-6-24 pure-u-xl-3-24"></div>
      </div>
      <div class="pure-g">
        <div class="newcsl_wrapper">
          <div class="pure-u-1 pure-u-md-7-24">
            <div class="section">
              <div class="image">
                <img src="/assets/img/anchillary-suplies.svg" />
              </div>
              <div class="content">
                <p>Upon enrolment, order <strong>ancillary supplies</strong> for your treatment
                  <strong>at no cost</strong>.
                </p>
              </div>
            </div>
          </div>
          <div class="pure-u-1 pure-u-md-1-24"></div>
          <div class="pure-u-1 pure-u-md-7-24 margin_top">
            <div class="section">
              <div class="image">
                <img src="/assets/img/insightful-digital.svg" />
              </div>
              <div class="content">
                <p>Access <strong>insightful digital and print resources</strong> to support you on
                  your
                  treatment journey.</p>
              </div>
            </div>
          </div>
          <div class="pure-u-1 pure-u-md-1-24"></div>
          <div class="pure-u-1 pure-u-md-7-24 margin_top">
            <div class="section">
              <div class="image">
                <img src="/assets/img/support-caller.svg" />
              </div>
              <div class="content">
                <p>Enjoy a personalized experience with <strong>24/7 access and support</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="pure-u-1 button_wrapper">
          <a href="https://cslbehringplus.rxdirect.ca" target="_blank" title="GO TO ORDERING PORTAL" class="btn">GO TO
            ORDERING PORTAL</a>
        </div>
        <div class="footnote">
          <p>*This ordering portal is for the purpose of obtaining ancillary supplies for training
            patients prescribed CSL Behring products. By using this portal, you agree that you will
            order the supplies needed only for patients prescribed CSL Behring products.</p>
        </div>
      </div>

    </div>

  </div>
  <div class="bg_gray">
    <div class="radius_border"></div>
  </div>
</section>
<section class="healthcare_professional_support" id="HCPS">
  <div class="content-container">
    <div class="pure-g">
      <div class="pure-u-1">
        <div class="title">
          <h2>
            Healthcare Professional Support
          </h2>
          <h3>
            CSL Behring is committed to supporting healthcare professionals in delivering patient care
          </h3>
        </div>
      </div>
    </div>
  </div>
  <div class="enrolment-form-wrapper">
    <div class="hcp-support-col">
      <div class="hcp-support-image" id="hcp-support-image">
        <img src="/assets/img/HCP_support.png" alt="HCP support Image" class="" />
      </div>
      <div class="gray-bg">
        <div class="content">
          <div class="image pure-u-1 pure-u-md-8-24">
            <img src="/assets/img/form_icon.svg" alt="Form Icon" class="" />
          </div>
          <div class="text pure-u-1 pure-u-md-13-24">
            <h3>
              The CSL Behring Healthcare Professionals Hub
            </h3>
            <p>
              Your <strong>one-stop source</strong> for resources for CSL Behring products, including product
              information, patient tools,
              and support materials.
            </p>
            <p>
              You can also enrol your patients in the <strong>CSL Plus<sup>&trade;</sup> Patient Support
                Program</strong>, designed to facilitate a
              patient’s treatment journey.
            </p>
            <p>
              <a href="https://hcp.cslbehring.ca/" target="_blank"
                title="Click here to log-in and download an enrolment form">Click here to log-in and download an
                enrolment form</a>
            </p>
          </div>
          <div class="pure-u-1 pure-u-md-3-24"></div>
        </div>
      </div>
    </div>
    <div class="content-container-zero">
      <div class="pure-g">
        <div class="pure-u-1">

        </div>
      </div>
    </div>
  </div>
</section>
<section class="contact" id="contactus">
  <div class="content-container">
    <div class="pure-g">
      <div class="pure-u-1 centered">
        <h2>
          Questions? We're here to help.
        </h2>
        <p>
          IF YOU HAVE ANY QUESTIONS, CONTACT THE CSL PLUS PATIENT SUPPORT PROGRAM AT:
        </p>
      </div>
    </div>
    <div class="pure-g col">
      <div class="pure-u-1 pure-u-md-6-24">
        <div>
          <img src="/assets/img/contact_icon.svg" alt="Email" class="" />
          <h3>Email</h3>
        </div>
        <div class="text">
          <p>
            <a href="mailto:support@cslplus.ca" title="support@cslplus.ca">
              support&#64;cslplus.ca
            </a>
          </p>
        </div>
      </div>
      <div class="pure-u-1 pure-u-md-3-24"></div>
      <div class="pure-u-1 pure-u-md-6-24">
        <div>
          <img src="/assets/img/contact_icon.svg" alt="Email" class="" />
          <h3>CALL</h3>
        </div>
        <div class="text">
          <p>
            <a href="tel:1-888-490-4105" title="1-888-490-4105">1-888-490-4105</a><br />
            Monday to Friday,<br />
            8 AM-8 PM EST
          </p>
        </div>
      </div>
      <div class="pure-u-1 pure-u-md-3-24"></div>
      <div class="pure-u-1 pure-u-md-6-24">
        <div>
          <img src="/assets/img/contact_icon.svg" alt="Email" class="" />
          <h3>Afterhours phone number for urgent inquiries:</h3>
        </div>
        <div class="text">
          <p>
            <a href="tel:(514) 219-7560" title="(514) 219-7560">(514) 219-7560</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>